import Vue from "vue";
import Router from "vue-router";
Vue.use(Router);

//Pages
import Login from "@/vues/Login/Login";
import BankLogin from "@/vues/Login/BankLogin";
import BankRegister from "@/vues/Login/BankRegister";
import BankResetPW from "@/vues/Login/BankResetPW";

import ResetPW from "@/vues/Login/ResetPW";

import Landing from "@/vues/Landing/Landing";
import Reporting from "@/vues/Landing/Reporting";
import Config from "@/vues/Landing/Config";

import Classes from "@/vues/Classes/Classes";
import Class from "@/vues/Classes/Class";
import ClassQR from "@/vues/Classes/ClassQR";
import ClassAssessment from "@/vues/Classes/ClassAssessment";
import DeliveryResponses from "@/vues/Classes/DeliveryResponses";
import ClassResults from "@/vues/Classes/ClassResults";
import StudentResults from "@/vues/Classes/StudentResults";
import StudentResultsPrint from "@/vues/Classes/StudentResultsPrint";

import TrafficDashboard from "@/vues/Landing/TrafficDashboard";
import SchoolDashboard from "@/vues/Landing/SchoolDashboard";

import Profile from "@/vues/Profile/Profile";
import Scoring from "@/vues/Scoring/Scoring";

import Viewer from "@/vues/Scoring/Viewer";
import HTMLView from "@/components/viewer/HTMLView";

import ViewExemplar from "@/vues/Scoring/ViewExemplar";

import Scan from "@/vues/Scan/Scan";
import SubmitWork from "@/vues/Scan/SubmitWork";
import PublicAssessments from "@/vues/Scan/PublicAssessments";
import PublicAssessment from "@/vues/Scan/PublicAssessment";
import BankProfile from "@/vues/Scan/BankProfile";

import ReportCompletion from "@/vues/QualityMgmt/ReportCompletion";
import ReportScorers from "@/vues/QualityMgmt/ReportScorers";
import ReportAssessmentSummary from "@/vues/QualityMgmt/ReportAssessmentSummary";
import ReportUserAgreement from "@/vues/QualityMgmt/ReportUserAgreement";
import Auditing from "@/vues/QualityMgmt/Auditing";
import ScoreAuditing from "@/vues/QualityMgmt/ScoreAuditing";

import RolesEdit from "@/vues/UserMgmt/RolesEdit";
import PendingUserSetup from "@/vues/UserMgmt/PendingUserSetup";
import UserSetup from "@/vues/UserMgmt/UserSetup";
import UserEdit from "@/vues/UserMgmt/UserEdit";
import TeamSetup from "@/vues/UserMgmt/TeamSetup";
import TeamEdit from "@/vues/UserMgmt/TeamEdit";

import TenantEdit from "@/vues/SetupConfig/TenantEdit";
import DistrictSetup from "@/vues/SetupConfig/DistrictSetup";
import DistrictEdit from "@/vues/SetupConfig/DistrictEdit";
import SchoolSetup from "@/vues/SetupConfig/SchoolSetup";
import SchoolEdit from "@/vues/SetupConfig/SchoolEdit";
import ClassList from "@/vues/SetupConfig/ClassList";
import ClassEdit from "@/vues/SetupConfig/ClassEdit";
import CourseList from "@/vues/SetupConfig/CourseList";
import CourseEdit from "@/vues/SetupConfig/CourseEdit";
import StudentList from "@/vues/SetupConfig/StudentList";
import ContentAreaSetup from "@/vues/SetupConfig/ContentAreaSetup";
import StandardSetup from "@/vues/SetupConfig/StandardSetup";
import StandardEdit from "@/vues/SetupConfig/StandardEdit";
import TaskBankSetup from "@/vues/SetupConfig/TaskBankSetup";
import CommentList from "@/vues/SetupConfig/CommentList"

import EssentialSkillSetup from "@/vues/SetupConfig/EssentialSkillSetup";
import EssentialSkillEdit from "@/vues/SetupConfig/EssentialSkillEdit";
import AssessmentPurposeSetup from "@/vues/SetupConfig/AssessmentPurposeSetup";
import AssessmentPurposeEdit from "@/vues/SetupConfig/AssessmentPurposeEdit";

import ContentAreaEdit from "@/vues/SetupConfig/ContentAreaEdit";
import AssessmentSetup from "@/vues/SetupConfig/AssessmentSetup";
import MyAssessments from "@/vues/SetupConfig/MyAssessments";
import MyAssessmentEdit from "@/vues/SetupConfig/MyAssessmentEdit";

import PendingAssessments from "@/vues/SetupConfig/PendingAssessments";
import AssessmentApprove from "@/vues/SetupConfig/AssessmentApprove";

import TemplateSetup from "@/vues/SetupConfig/TemplateSetup";
import TemplateEdit from "@/vues/SetupConfig/TemplateEdit";

import AssessmentEdit from "@/vues/SetupConfig/AssessmentEdit";
import AssessmentAssign from "@/vues/SetupConfig/AssessmentAssign";

import ItemSetup from "@/vues/SetupConfig/ItemSetup";
import ItemEdit from "@/vues/SetupConfig/ItemEdit";
import RubricSetup from "@/vues/SetupConfig/RubricSetup";
import RubricEdit from "@/vues/SetupConfig/RubricEdit";

//Services
import AuthService from "@/services/AuthService";
import ThemeService from "@/services/ThemeService";
import notie from "@/services/NotieService";
import _ from "lodash";

const router = new Router({
	routes: [
		{
			path: "/",
			name: "Login",
			component: Login
		},
		{
			path: "/public/login/:tenantID",
			name: "BankLogin",
			component: BankLogin
		},
		{
			path: "/public/register/:tenantID",
			name: "BankRegister",
			component: BankRegister
		},
		{
			path: "/public/resetpw/:tenantID",
			name: "BankResetPW",
			component: BankResetPW
		},
		{
			path: "/resetpw",
			name: "ResetPW",
			component: ResetPW
		},
		{
			path: "/landing",
			name: "Landing",
			component: Landing,
			props: initProps
		},
		{
			path: "/reporting",
			name: "Reporting",
			component: Reporting,
			props: initProps
		},
		{
			path: "/config",
			name: "Configuration",
			component: Config,
			props: initProps
		},
		{
			path: "/classes",
			name: "Classes",
			component: Classes,
			props: initProps
		},
		{
			path: "/class/:classID",
			name: "Class",
			component: Class,
			props: initProps
		},
		{
			path: "/class/qr/:classID",
			name: "Class QR",
			component: ClassQR,
			props: initProps
		},
		{
			path: "/class/:classID/assessment/:asmtID",
			name: "ClassAssessment",
			component: ClassAssessment,
			props: initProps
		},
		{
			path: "/class/:classID/assessment/:asmtID/results",
			name: "ClassResults",
			component: ClassResults,
			props: initProps
		},
		{
			path: "/class/:classID/assessment/:asmtID/delivery/:deliveryID",
			name: "DeliveryResponses",
			component: DeliveryResponses,
			props: initProps
		},
		// Public QR paths
		{
			path: "/scan",
			name: "Scan",
			component: Scan
		},
		{
			path: "/submit/:studentID",
			name: "Submit",
			component: SubmitWork
		},
		{
			path: "/public/profile/:tenantID",
			name: "BankProfile",
			component: BankProfile,
		},
		{
			path: "/public/tasks/:tenantID",
			name: "PublicAssessments",
			component: PublicAssessments,
		},
		{
			path: "/public/task/:taskID",
			name: "PublicAssessment",
			component: PublicAssessment,
			props: publicProps

		},
		{
			path: "/dashboard/school",
			name: "SchoolDashboard",
			component: SchoolDashboard,
			props: initProps
		},
		{
			path: "/dashboard/traffic",
			name: "Traffic Dashboard",
			component: TrafficDashboard,
			props: initProps
		},
		{
			path: "/htmlview/:assessmentID/:sequence",
			name: "HTMLView",
			component: HTMLView,
			props: initProps
		},
		// {
		// 	path: "/dashboard",
		// 	name: "Dashboard",
		// 	component: Dashboard,
		// 	props: initProps
		// },
		// {
		// 	path: "/supervisor_dashboard",
		// 	name: "SupervisorDashboard",
		// 	component: SupervisorDashboard,
		// 	props: initProps
		// },
		// {
		// 	path: "/project_dashboard",
		// 	name: "ProjectDashboard",
		// 	component: ProjectDashboard,
		// 	props: initProps
		// },
		{
			path: "/profile",
			name: "Profile",
			component: Profile,
			props: initProps
		},
		{
			path: "/scoring",
			name: "Scoring",
			component: Scoring,
			props: initProps
		},
		{
			path: "/class/:classID/student/:studentID/results",
			name: "StudentResults",
			component: StudentResults,
			props: initProps
		},
		{
			path: "/class/:classID/student/:studentID/results/print",
			name: "StudentResultsPrint",
			component: StudentResultsPrint,
			props: initProps
		},
		{
			path: "/class/:classID/all_results/print",
			name: "StudentResultsPrint",
			component: StudentResultsPrint,
			props: initProps
		},

		{
			path: "/scoring/:assessment_id/:item_id/:class_id/:delivery_id",
			name: "ViewerFirstScore",
			component: Viewer,
			props: modeFirstScore
		},
		{
			path: "/second_score/:assessment_id/:item_id",
			name: "ViewerSecondScore",
			component: Viewer,
			props: modeSecondScore
		},
		{
			path: "/resolution/:assessment_id/:item_id",
			name: "ViewerResolution",
			component: Viewer,
			props: modeResolution
		},
		{
			path:
				"/single_score/:assessment_id/:item_id/:class_id/:delivery_id/:response_id",
			name: "ViewerSingleScore",
			component: Viewer,
			props: modeSingleScore
		},
		{
			path: "/view/:assessment_id/:item_id/:response_id",
			name: "ViewerViewing",
			component: Viewer,
			props: modeViewing
		},
		{
			path: "/view_unread",
			name: "ViewerViewAll",
			component: Viewer,
			props: modeViewAll
		},

		{
			path: "/exemplar/:rubric_id/:trait_id/:score/:exemplar_id",
			name: "ViewExemplar",
			component: ViewExemplar,
			props: initProps
		},
		//==========================

		{
			path: "/reporting/completion",
			name: "ReportCompletion",
			component: ReportCompletion,
			props: initProps
		},
		{
			path: "/reporting/scorers",
			name: "ReportScorers",
			component: ReportScorers,
			props: initProps
		},
		{
			path: "/reporting/assessment_summary",
			name: "ReportAssessmentSummary",
			component: ReportAssessmentSummary,
			props: initProps
		},
		{
			path: "/reporting/user_agreement",
			name: "ReportUserAgreement",
			component: ReportUserAgreement,
			props: initProps
		},
		{
			path: "/auditing",
			name: "Auditing",
			component: Auditing,
			props: initProps
		},
		{
			path: "/score_auditing",
			name: "ScoreAuditing",
			component: ScoreAuditing,
			props: initProps
		},
		{
			path: "/audit/:assessment_id/:item_id/:response_id",
			name: "AuditViewer",
			component: Viewer,
			props: modeAuditing
		},
		{
			path: "/roles",
			name: "RolesEdit",
			component: RolesEdit,
			props: initProps
		},
		{
			path: "/pending_users",
			name: "PendingUserSetup",
			component: PendingUserSetup,
			props: initProps
		},
		{
			path: "/users",
			name: "UserSetup",
			component: UserSetup,
			props: initProps
		},
		{
			path: "/users/:id",
			name: "UserEdit",
			component: UserEdit,
			props: initProps
		},
		{
			path: "/teams",
			name: "TeamSetup",
			component: TeamSetup,
			props: initProps
		},
		{
			path: "/teams/:id",
			name: "TeamEdit",
			component: TeamEdit,
			props: initProps
		},
		{
			path: "/tenant",
			name: "TenantEditCurrent",
			component: TenantEdit,
			props: currentTenantProps
		},
		{
			path: "/taskbank",
			name: "TaskBankSetup",
			component: TaskBankSetup,
			props: initProps
		},
		{
			path: "/bank_comments",
			name: "CommentList",
			component: CommentList,
			props: initProps
		},
		{
			path: "/districts",
			name: "DistrictSetup",
			component: DistrictSetup,
			props: initProps
		},
		{
			path: "/district/:id",
			name: "DistrictEdit",
			component: DistrictEdit,
			props: initProps
		},
		{
			path: "/schools",
			name: "SchoolSetup",
			component: SchoolSetup,
			props: initProps
		},
		{
			path: "/school/:id",
			name: "SchoolEdit",
			component: SchoolEdit,
			props: initProps
		},
		{
			path: "/admin/classes",
			name: "ClassList",
			component: ClassList,
			props: initProps
		},
		{
			path: "/admin/courses",
			name: "CourseList",
			component: CourseList,
			props: initProps
		},
		{
			path: "/admin/course/:id",
			name: "CourseEdit",
			component: CourseEdit,
			props: initProps
		},
		{
			path: "/admin/classes/:id",
			name: "ClassEdit",
			component: ClassEdit,
			props: initProps
		},
		{
			path: "/students",
			name: "StudentList",
			component: StudentList,
			props: initProps
		},
		{
			path: "/content_areas",
			name: "ContentAreaSetup",
			component: ContentAreaSetup,
			props: initProps
		},
		{
			path: "/content_area/:id",
			name: "ContentAreaEdit",
			component: ContentAreaEdit,
			props: initProps
		},
		{
			path: "/standards",
			name: "StandardSetup",
			component: StandardSetup,
			props: initProps
		},
		{
			path: "/standards/:id",
			name: "StandardEdit",
			component: StandardEdit,
			props: initProps
		},
		{
			path: "/essential_skills",
			name: "EssentialSkillSetup",
			component: EssentialSkillSetup,
			props: initProps
		},
		{
			path: "/essential_skills/:id",
			name: "EssentialSkillEdit",
			component: EssentialSkillEdit,
			props: initProps
		},
		{
			path: "/assessment_purpose",
			name: "AssessmentPurposeSetup",
			component: AssessmentPurposeSetup,
			props: initProps
		},
		{
			path: "/assessment_purpose/:id",
			name: "AssessmentPurposeEdit",
			component: AssessmentPurposeEdit,
			props: initProps
		},
		{
			path: "/items",
			name: "ItemSetup",
			component: ItemSetup,
			props: initProps
		},
		{
			path: "/items/:id",
			name: "ItemEdit",
			component: ItemEdit,
			props: initProps
		},
		{
			path: "/assessments",
			name: "AssessmentSetup",
			component: AssessmentSetup,
			props: initProps
		},
		{
			path: "/myassessments",
			name: "MyAssessments",
			component: MyAssessments,
			props: initProps
		},
		{
			path: "/myassessments/:id",
			name: "MyAssessmentEdit",
			component: MyAssessmentEdit,
			props: initProps
		},
		{
			path: "/assessmentapprove/:id",
			name: "AssessmentApprove",
			component: AssessmentApprove,
			props: initProps
		},
		{
			path: "/pendingassessments",
			name: "PendingAssessments",
			component: PendingAssessments,
			props: initProps
		},
		{
			path: "/assessments/:id",
			name: "AssessmentEdit",
			component: AssessmentEdit,
			props: initProps
		},
		{
			path: "/assessments/assign/:id",
			name: "AssessmentAssign",
			component: AssessmentAssign,
			props: initProps
		},
		{
			path: "/templates",
			name: "TemplateSetup",
			component: TemplateSetup,
			props: initProps
		},
		{
			path: "/templates/:id",
			name: "TemplateEdit",
			component: TemplateEdit,
			props: initProps
		},
		{
			path: "/rubrics",
			name: "RubricSetup",
			component: RubricSetup,
			props: initProps
		},
		{
			path: "/rubrics/:id",
			name: "RubricEdit",
			component: RubricEdit,
			props: initProps
		}
	]
});

function initProps(route) {
	let props = {
		user: route.meta.user,
		params: route.params,
		query: route.query
	};
	return props;
}
function publicProps(route) {
	let props = {
		assessment: route.meta.assessment,
	};
	return props;
}

function currentTenantProps(route) {
	let props = {
		user: route.meta.user,
		params: {
			id: "current"
		},
		query: route.query
	};
	return props;
}

//New scoring modes for MICSS
function modeFirstScore(route) {
	route.params.mode = "FIRST";
	return initProps(route);
}

function modeSecondScore(route) {
	route.params.mode = "SECOND";
	return initProps(route);
}

function modeResolution(route) {
	route.params.mode = "RESOLUTION";
	return initProps(route);
}

function modeSingleScore(route) {
	route.params.mode = "SINGLE";
	return initProps(route);
}

function modeViewing(route) {
	route.params.mode = "VIEWING";
	return initProps(route);
}

function modeViewAll(route) {
	route.params.mode = "VIEW ALL";
	return initProps(route);
}
//===========================

function modeBackread(route) {
	route.params.mode = "BACKREAD";
	return initProps(route);
}

function modeQueueBackread(route) {
	route.params.mode = "QUEUE BACKREAD";
	return initProps(route);
}

function modeFlagQueue(route) {
	route.params.mode = "FLAG QUEUE";
	return initProps(route);
}

function modeAuditing(route) {
	route.params.mode = "AUDITING";
	return initProps(route);
}

function modeQCTrueScore(route) {
	route.params.mode = "QC_TRUE_SCORE";
	return initProps(route);
}

function modeTraining(route) {
	route.params.mode = "TRAINING";
	return initProps(route);
}

function modeRangefinding(route) {
	route.params.mode = "RANGEFINDING";
	return initProps(route);
}

//Map routes to permission fields in the User.Roles struct
let userPermissions = {
	// "/bulletin_board": "page_bulletin_board",
	"/dashboard/school": "page_school_dashboard",
	"/dashboard/traffic": "page_traffic_dashboard",
	// "/dashboard": "page_dashboard",
	// "/supervisor_dashboard": "page_supervisor_dashboard",
	// "/project_dashboard": "page_project_dashboard",

	//New scoring routes for MICSS
	"/scoring/:assessment_id/:item_id/:class_id/:delivery_id": "manage_classes",
	"/second_score/:assessment_id/:item_id": "second_score",
	"/resolution/:assessment_id/:item_id": "resolution_score",
	"/single_score/:assessment_id/:item_id/:class_id/:delivery_id/:response_id":
		"manage_classes",
	"/view/:assessment_id/:item_id/:response_id": "manage_classes",
	"/view_unread": "manage_classes",
	//============================

	"/scoring": "scorer_entry",
	"/scoring/:section_id/:item_id": "page_scoring",
	// "/training/:section_id/:item_id/:set_id": "page_scoring",
	// "/rangefinding/:section_id/:item_id/:set_id": "rf_score",
	// "/qc_set_report/:set_id": "page_scoring",
	// "/rf_set_report/:set_id": "rf_score",
	// "/resolution/:section_id/:item_id": "has_resolution",
	// "/backread/:section_id/:item_id": "page_backreading",
	// "/qbackread/:section_id/:item_id/:queue_user_id/:skip_interval":
	// 	"page_backreading",
	// "/flag_queue/:section_id/:item_id/:alert_id": "page_auditing",
	// "/project_summary": "page_project_summary",
	// "/backreading/:section_id/:item_id": "page_backreading",
	// "/mail": "page_mail",
	"/reporting/completion": "page_report_completion",
	"/reporting/scorers": "page_report_scorers",
	"/reporting/assessment_summary": "page_asmt_summary",
	"/reporting/user_agreement": "page_user_agreement",

	// "/reporting/payroll": "page_payroll",
	// "/reporting/daily": "page_reporting",
	// "/reporting/user_summary": "page_reporting",
	// "/reporting/project_agreement": "page_reporting",
	// "/calc/burndown": "page_reporting",

	"/auditing": "page_auditing",
	"/score_auditing": "page_auditing",
	"/reset_history": "page_auditing",
	"/audit/:assessment_id/:item_id/:response_id": "page_auditing",

	// "/qc_setup": "page_qc_setup",
	// "/qc_reporting/:qcType": "page_qc_report",
	// "/qc_true_score/:section_id/:item_id/:qc_response_id": "page_qc_setup",
	// "/qc_setup/set/:setID": "page_qc_setup",
	// "/rf_setup": "page_rf_setup",
	// "/rf_setup/set/:setID": "page_rf_setup",
	// "/rf_reporting": "page_rf_report",
	// "/rf_response/:respID": "page_rf_report",

	"/roles": "page_config_current_tenant",
	"/pending_users": "page_config_users",
	"/users": "page_config_users",
	"/users/:id": "page_config_users",
	"/teams": "page_config_teams",
	"/teams/:id": "page_config_teams",
	"/taskbank": "page_config_current_tenant",
	"/bank_comments": "moderate_bank_comments",

	"/tenants": "page_config_tenants",
	"/tenants/:id": "page_config_tenants",
	"/tenant": "page_config_current_tenant",
	"/districts": "page_config_districts",
	"/district/:id": "page_config_districts",
	"/schools": "page_config_schools",
	"/school/:id": "page_config_schools",
	"/admin/classes": "page_config_classes",
	"/admin/classes/:id": "page_config_classes",
	"/admin/courses": "page_config_courses",
	"/admin/course/:id": "page_config_courses",
	"/students": "page_config_students",
	"/content_areas": "page_config_content_areas",
	"/content_area/:id": "page_config_content_areas",
	"/projects": "page_config_projects",
	"/projects/:id": "page_config_projects",
	"/sections": "page_config_sections",
	"/sections/:id": "page_config_sections",
	"/items": "page_config_items",
	"/items/:id": "page_config_items",
	"/items/:id/:tab": "page_config_items",
	"/assessments": ["page_config_assessments", "page_assign_assessments"],
	"/assessments/:id": "page_config_assessments",
	"/assessments/assign/:id": "page_assign_assessments",

	"/myassessments": "page_create_from_template",
	"/myassessments/:id": "page_create_from_template",

	"/pendingassessments": "page_approve_assessment",
	"/assessmentapprove/:id": "page_approve_assessment",


	"/templates": "page_create_template",
	"/templates/:id": "page_create_template",

	"/rubrics": "page_config_rubrics",
	"/rubrics/:id": "page_config_rubrics",

	"/standards": "page_config_standards",
	"/standards/:id": "page_config_standards",

	"/essential_skills": "page_config_standards",
	"/essential_skills/:id": "page_config_standards",

	"/assessment_purpose": "page_config_standards",
	"/assessment_purpose/:id": "page_config_standards",


	"/classes": "teacher_entry",
	"/class/:classID": "manage_classes",
	"/class/:classID/assessment/:asmtID": "manage_classes",
	"/class/:classID/assessment/:asmtID/delivery/:deliveryID": "manage_classes",
	"/class/:classID/assessment/:asmtID/results": "manage_classes",
	"/class/:classID/student/:studentID/results": "manage_classes",
	"/class/:classID/student/:studentID/results/print": "manage_classes",
	"/class/:classID/all_results/print": "manage_classes",
	"/class/qr/:classID": "manage_classes"
};

//But some routes should be allowable to all users
let globalPermissions = {
	"/landing": true,
	"/reporting": true,
	"/config": true,
	"/profile": true,

	"/exemplar/:rubric_id/:trait_id/:score/:exemplar_id": true
};

//And some routes should be allowed to external visitors to the website
let externalPermissions = {
	"/": true,
	"/resetpw": true,
	"/scan": true,
	"/submit/:studentID": true,
	"/htmlview/:assessmentID/:sequence": true,
	"/public/tasks/:tenantID": true,
	"/public/task/:taskID": true,
	"/public/login/:tenantID": true,
	"/public/register/:tenantID": true,
	"/public/profile/:tenantID": true,
	"/public/resetpw/:tenantID": true


};

router.beforeEach((to, from, next) => {
	console.log("----Routing '" + to.path + "' to " + to.name + "----");

	// debugger;
	if (
		externalPermissions[to.path] ||
		externalPermissions[to.matched[0].path]
	) {
		console.log("Router go next");
		next();
		return;
	}

	AuthService.getUser()
		.then(user => {
			console.log("GOT USER", user);
			to.meta.user = user;
			//TODO hook back up to role
			ThemeService.setTheme(user.role.theme);
			if (hasPermissions(to, user)) {
				console.log("User", user, user.full_name, "had permission", to);
				next();
			} else {
				console.log(to);
				notie.info(
					`<h4>You are not allowed here!</h4><div class="text-muted">${to.path}</div>`
				);
				next(false);
			}
		})
		.catch(err => {
			console.log(err);
			notie.info("<h4>You are not logged in</h4>");
			next("/");
		});
});

function hasPermissions(route, user) {
	//We have to look at the matched routes, not the path itself so we can have dynamic paths
	//i.e. /items/afd78baxy0x cannot be compared to a page directly, but /items/:id can
	var hasPermission = false;

	_.each(route.matched, function (match) {
		//First check global permissions
		if (globalPermissions[match.path]) {
			hasPermission = true;
			return;
		}

		//Now check the role permissions
		var permissionNeeded = userPermissions[match.path];
		if (typeof permissionNeeded == "string") {
			if (user.role[permissionNeeded]) {
				hasPermission = true;
			}
		} else if (typeof permissionNeeded == "object") {
			//If multiple permissions are defined for a single route, check if at least one is valid
			_.each(permissionNeeded, pn => {
				if (user.role[pn]) {
					hasPermission = true;
				}
			})
		}
	});

	return hasPermission;
}

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js